import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { configDataConstants, configurationConstants, } from "../store/actions/types";
const LegsFeatureName = "Legs";
const CClusterLegsFeatureName = "C Cluster Legs";
const HandRestFeatureName = "Hand Rest";
const WireManagement2 = "Wire Management";
const wmsr = "Wire Management (Side Radius)";
const wm1 = "Wire Management (Plain)";
const wm2 = "Wire Management (Side Radius)";
const wmrw = "Wire Management (Reverse Waterfall)";
const wmp = "Wire Management (Plain)";
const BaseFeatureName = "Base";
const btable = "Below Table TableTop Tile";
const PrivacyFeatureName = "Privacy";
const btt = "Below Table Table Top Tile";
const attp = "Intermediate Panel";
const AccessoriesFeatureName = "Accessories";
const MetalFeatureName = "Powder Coat";
const pco = "Privacy Color Options";
const Pcolor = "Plastic Color";
const MechanismFeatureName = "Mechanism";
const ColorOptionsPrivacy = "Color Options Privacy";
const GlassesFeatureName = "Glass Color";
const FabricFeatureName = "Fabric Color";
const WoodFeatureName = "Laminate";
const bw = "Bottom Laminate";
const lc = "Prelam Leg Laminate";
const WheelsFeatureName = "Wheels";
const PedestalFeatureName = "Pedestal";
const tt = "Table Top";
const PedestalFeatureHandleName = "Handle";
const Storages = "Storages";
const PedestalFeatureLockName = "Lock";
const System = "System";
const Dimensions = "Dimensions";
const PedestalFeatureCushionName = "Cushion";
const PedestalFeatureDrawerWoodName = "Pedestal Facia";
const sf = "Storage Facia";
const ss = "Storage Side";
const PedestalFeatureSideWoodName = "Pedestal Side";
const PedestalFeatureTopWoodName = "Pedestal Top";
const PedestalFeatureFabricName = "Fabric";
const SideTableFeatureName = "Pedestals";
const LegColorFeatureName = "Color Options";
const useUserConfiguration = () => {
    const dispatch = useAppDispatch();
    const userConfiguration2 = useAppSelector((state) => state.configuration.userConfiguration2);
    const specs = useAppSelector((state) => state.configData.current);
    const specsOriginal = useAppSelector((state) => state.configData.original);
    const enableDisableOptions = (option) => {
        const { disableFeatures, enableFeatures, disableOptions, enableOptions } = option;
        if (disableFeatures) {
            dispatch({
                type: configurationConstants.DISABLE_FEATURES,
                payload: disableFeatures,
            });
        }
        if (enableFeatures) {
            dispatch({
                type: configurationConstants.ENABLE_FEATURES,
                payload: enableFeatures,
            });
        }
        if (disableOptions) {
            let userConfiguration2Copy = Object.assign({}, userConfiguration2);
            let updated = false;
            for (const configKey in userConfiguration2Copy) {
                if (disableOptions.includes(userConfiguration2Copy[configKey])) {
                    userConfiguration2Copy[configKey] = "None";
                    updated = true;
                }
            }
            if (updated) {
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: userConfiguration2Copy,
                });
            }
            dispatch({
                type: configurationConstants.DISABLE_OPTIONS,
                payload: disableOptions,
            });
        }
        if (enableOptions) {
            dispatch({
                type: configurationConstants.ENABLE_OPTIONS,
                payload: enableOptions,
            });
        }
    };
    const removeDependentFeatures = (value) => {
        var _a, _b;
        (_b = (_a = value.option) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.forEach((subFeature) => {
            const option = userConfiguration2[subFeature.name];
            if (option) {
                !subFeature.options
                    .map((_option) => _option.name)
                    .includes(option) &&
                    dispatch({
                        type: configurationConstants.DELETE_PROPERTY,
                        payload: subFeature.name,
                    });
            }
        });
    };
    const updateUserConfiguration = (featureName, value) => {
        var _a, _b, _c, _d, _e, _f;
        enableDisableOptions(value.option);
        removeDependentFeatures(value);
        switch (featureName) {
            case "System":
                const newConfigData = specsOriginal.map((item) => {
                    var _a, _b;
                    const filteredOptions = item.options
                        .filter((option) => {
                        if (item.name === "System")
                            return true;
                        return option.name === value.name;
                    })
                        .map((option) => (Object.assign({}, option)));
                    if (item.name === "System")
                        return Object.assign(Object.assign({}, item), { options: filteredOptions });
                    return Object.assign(Object.assign({}, item), { options: (_a = filteredOptions[0]) === null || _a === void 0 ? void 0 : _a.options, rules: (_b = filteredOptions[0]) === null || _b === void 0 ? void 0 : _b.rules });
                });
                dispatch({
                    type: configDataConstants.SET_CURRENT_CONFIG_DATA,
                    payload: newConfigData,
                });
                if (value.option.Category == "Linear Workstation") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ type: value.name, [value.name]: value.option.name, noOfSeats: value.option.size }, (value.option.id && { id: value.option.id })), (((_a = value.option) === null || _a === void 0 ? void 0 : _a.name) && { name: (_b = value.option) === null || _b === void 0 ? void 0 : _b.name })), (value.option.Length && { Length: value.option.Length })), (value.option.Height && { Height: value.option.Height })), (value.option.Depth && { Depth: value.option.Depth })), (value.option.Dia && { Dia: value.option.Dia })), (value.option.table && { table: value.option.table })), (value.option.Category && { Category: value.option.Category })), (value.option["Table Top Options"] && {
                            "Table Top Options": value.option["Table Top Options"],
                        })),
                    });
                }
                else {
                    if (value.option.Category == "Discussion Table") {
                        if (userConfiguration2.type) {
                            const old_type = userConfiguration2.type;
                            for (const key of Object.keys(userConfiguration2)) {
                                if (key == old_type || userConfiguration2[key] == old_type) {
                                    delete userConfiguration2[key];
                                }
                            }
                        }
                    }
                    const configData = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ type: value.name, [value.name]: value.option.name, noOfSeats: value.option.size }, (value.option.id && { id: value.option.id })), (((_c = value.option) === null || _c === void 0 ? void 0 : _c.name) && { name: (_d = value.option) === null || _d === void 0 ? void 0 : _d.name })), (value.option.Length && { Length: value.option.Length })), (value.option.Height && { Height: value.option.Height })), (value.option.Depth && { Depth: value.option.Depth })), (value.option.Dia && { Dia: value.option.Dia })), (value.option.table && { table: value.option.table })), (value.option.Category && { Category: value.option.Category })), (value.option["Table Top Options"] && {
                        "Table Top Options": value.option["Table Top Options"],
                    }));
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: configData,
                    });
                }
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { "Fabric Panel Accessories": null },
                });
                break;
            case "Dimensions":
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { [value.name]: value.option.value },
                });
                break;
            // case AccessoriesFeatureName:
            case MetalFeatureName:
            case MechanismFeatureName:
            case GlassesFeatureName:
            case FabricFeatureName:
            case WoodFeatureName:
            case bw:
            case lc:
            case WheelsFeatureName:
            case Pcolor:
            case PedestalFeatureLockName:
            case btt:
            case PedestalFeatureCushionName:
            case PedestalFeatureDrawerWoodName:
            case sf:
            case ss:
            case wmrw:
            case wmp:
            case wmsr:
            case PedestalFeatureSideWoodName:
            case PedestalFeatureTopWoodName:
            case PedestalFeatureFabricName:
            case LegColorFeatureName:
            case ColorOptionsPrivacy:
            case PedestalFeatureName:
            case SideTableFeatureName:
                let _value = value.option.name;
                console.log("_value", _value);
                if (value.multiSelect) {
                    _value = ((_e = userConfiguration2[featureName]) === null || _e === void 0 ? void 0 : _e.includes(value.option.name))
                        ? userConfiguration2[featureName].filter((_value) => _value !== value.option.name)
                        : [...(userConfiguration2[featureName] || []), value.option.name];
                }
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { [featureName]: _value },
                });
                break;
            case LegsFeatureName:
                if (value.name == "Legs" && value.option.name != "Eco") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: {
                            [value.name]: value.option.name,
                            "Eco Size Options": null,
                        },
                    });
                }
                else if (value.name == "Leg") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Wire Management": null },
                    });
                }
                else {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Side Radius Raceway Options": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Plain Raceway Options": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Reverse Waterfall Raceway Options": null },
                    });
                }
                break;
            case CClusterLegsFeatureName:
                if (value.name == "C Cluster Legs") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Wire Management": null },
                    });
                }
                else {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Side Radius Raceway Options": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Plain Raceway Options": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Reverse Waterfall Raceway Options": null },
                    });
                }
                break;
            case BaseFeatureName:
            case Storages:
                if (value.option.name == "Return Eco") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name, Legs: "Eco" },
                    });
                }
                else if (value.option.name == "Return IO") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name, Legs: "Io" },
                    });
                }
                else if (value.option.name == "Return Scope") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name, Legs: "Scope" },
                    });
                }
                else {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name },
                    });
                }
                break;
            case HandRestFeatureName:
                if (value.option.name == "Return Table Top") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { Legs: null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimension Options": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimension Option": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimensions Option": null },
                    });
                }
                if (value.option.name == "None") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { Back: null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Table Top Leg": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimension Options": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimension Option": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimensions Option": null },
                    });
                }
                if (value.option.name == "Return Storage") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Table Top Leg": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimension Options": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimension Option": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimensions Option": null },
                    });
                }
                if (value.option.name == "Return Storage 2") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Table Top Leg": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimension Options": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimension Option": null },
                    });
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Return Dimensions Option": null },
                    });
                }
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { [value.name]: value.option.name },
                });
                return;
            case tt:
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { "Side Radius Raceway Options": null },
                });
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { [value.name]: value.option.name },
                });
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { "Plain Raceway Options": null },
                });
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { "Plain Wire Management's Dimensions": null },
                });
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { "Side Radius Wire Management's Dimensions": null },
                });
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { "Reverse Waterfall Raceway Options": null },
                });
                return;
            // case PrivacyFeatureName:
            //   let _valuee;
            //   if (value.multiSelect) {
            //     // Retrieve the existing options, defaulting to an empty array
            //     const existingOptions = userConfiguration2[value.name] || [];
            //     // Toggle: Remove the option if it's already included, add otherwise
            //     if (existingOptions.includes(value.option.name)) {
            //       _valuee = existingOptions.filter(
            //         (selectedOption: string) => selectedOption !== value.option.name
            //       );
            //     } else {
            //       _valuee = [...existingOptions, value.option.name];
            //     }
            //   } else {
            //     _valuee = value.option.name;
            //   }
            //   console.log("_value", _valuee, value);
            //   // Handle the special case for "Hung Panel"
            //   if (value.option.name === "Hung Panel") {
            //     dispatch({
            //       type: configurationConstants.UPDATE_CONFIGURATION2,
            //       payload: { "Side Modesty": "None" },
            //     });
            //   }
            //   // Dispatch the updated configuration with the new value(s)
            //   dispatch({
            //     type: configurationConstants.UPDATE_CONFIGURATION2,
            //     payload: { [value.name]: _valuee },
            //   });
            //   return;
            case PrivacyFeatureName:
                let _valuee = value.option.name;
                console.log("_value", _valuee, value);
                if (value.multiSelect) {
                    _valuee = ((_f = userConfiguration2[featureName]) === null || _f === void 0 ? void 0 : _f.includes(value.option.name))
                        ? userConfiguration2[featureName].filter((_valuee) => _valuee !== value.option.name)
                        : [...(userConfiguration2[featureName] || []), value.option.name];
                }
                if (value.option.name == "Hung Panel") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { "Side Modesty": "None" },
                    });
                }
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { [value.name]: value.option.name },
                });
                return;
            case PedestalFeatureHandleName:
            case Dimensions:
            case wm1:
            case wm2:
            case "System":
            case attp:
            case btable:
            case pco:
            case WireManagement2:
                if (value.name == "Raceway Sharing" && value.option.name != "Flip Up") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: {
                            [value.name]: value.option.name,
                            "Wire Management's Dimensions Sharing": null,
                        },
                    });
                }
                else if (value.name == "Raceway Non Sharing" &&
                    value.option.name != "Flip Up") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: {
                            [value.name]: value.option.name,
                            "Wire Management's Dimensions Non Sharing": null,
                        },
                    });
                }
                else if (value.name == "Plain Raceway Options" &&
                    value.option.name != "Flip Up") {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: {
                            [value.name]: value.option.name,
                            "Plain Wire Management's Dimensions": "",
                        },
                    });
                }
                else {
                    dispatch({
                        type: configurationConstants.UPDATE_CONFIGURATION2,
                        payload: { [value.name]: value.option.name },
                    });
                }
                // dispatch({
                //   type: configurationConstants.UPDATE_CONFIGURATION2,
                //   payload: {
                //     [AccessoriesFeatureName]: [],
                //   },
                // });
                return;
            case AccessoriesFeatureName:
                dispatch({
                    type: configurationConstants.UPDATE_CONFIGURATION2,
                    payload: { [value.name]: value.option.name },
                });
                // dispatch({
                //   type: configurationConstants.UPDATE_CONFIGURATION2,
                //   payload: {
                //     [AccessoriesFeatureName]: [],
                //   },
                // });
                return;
            default:
                break;
        }
    };
    const getSelectedOption = (featureName, subFeatureName) => {
        var _a, _b, _c, _d, _e, _f;
        const Feature = specs.find((x) => x.name === featureName);
        if (!Feature)
            return [];
        switch (featureName) {
            case "System":
                if (subFeatureName !== userConfiguration2.type) {
                    return [];
                }
                try {
                    const system = Feature;
                    const sharingOrNonSharing = system.options.find((x) => x.name === userConfiguration2.type);
                    const selectedOption = (sharingOrNonSharing === null || sharingOrNonSharing === void 0 ? void 0 : sharingOrNonSharing.options).find((option) => option.size === userConfiguration2.noOfSeats);
                    return selectedOption ? [selectedOption] : [];
                }
                catch (error) {
                    return [];
                }
            case "Dimensions":
                const subFeature = (_a = Feature.options) === null || _a === void 0 ? void 0 : _a.find((x) => x.name === subFeatureName);
                const selectedOption2 = (_b = subFeature === null || subFeature === void 0 ? void 0 : subFeature.options) === null || _b === void 0 ? void 0 : _b.find((option) => option.value === userConfiguration2[(subFeature === null || subFeature === void 0 ? void 0 : subFeature.name) || ""]);
                return selectedOption2 ? [selectedOption2] : [];
            // case AccessoriesFeatureName:
            case PedestalFeatureName:
            case SideTableFeatureName:
            case ColorOptionsPrivacy:
            case MetalFeatureName:
            case MechanismFeatureName:
            case GlassesFeatureName:
            case FabricFeatureName:
            case WoodFeatureName:
            case WheelsFeatureName:
            case bw:
            case lc:
            case btt:
            case Pcolor:
            case PedestalFeatureLockName:
            case PedestalFeatureCushionName:
            case PedestalFeatureDrawerWoodName:
            case sf:
            case ss:
            case wmrw:
            case wmp:
            case wmsr:
            case PedestalFeatureSideWoodName:
            case PedestalFeatureTopWoodName:
            case PedestalFeatureFabricName:
                console.log("feature", Feature);
                if (Feature.multiSelect) {
                    console.log("feature", Feature);
                    const selectedOption3 = Feature.options.filter((x) => { var _a; return (_a = userConfiguration2[Feature.name]) === null || _a === void 0 ? void 0 : _a.includes(x.name); });
                    return selectedOption3;
                }
                else {
                    const selectedOption3 = (_c = Feature.options) === null || _c === void 0 ? void 0 : _c.find((option) => option.name === userConfiguration2[Feature.name]);
                    return selectedOption3 ? [selectedOption3] : [];
                }
            case pco:
            case PrivacyFeatureName:
            case btable:
            case WireManagement2:
            case AccessoriesFeatureName:
            case BaseFeatureName:
            case PedestalFeatureHandleName:
            case Dimensions:
            case tt:
            case wm1:
            case wm2:
            case attp:
            case HandRestFeatureName:
            case "System":
            case LegsFeatureName:
            case CClusterLegsFeatureName:
            case Storages:
                let subFeature2 = (_d = Feature.options) === null || _d === void 0 ? void 0 : _d.find((x) => x.name === subFeatureName);
                if (!subFeature2) {
                    (_e = Feature.options) === null || _e === void 0 ? void 0 : _e.forEach((x) => {
                        var _a;
                        if (getSelectedOption(featureName, x.name) instanceof Array) {
                            (_a = getSelectedOption(featureName, x.name)) === null || _a === void 0 ? void 0 : _a.forEach((option) => {
                                var _a;
                                (_a = option === null || option === void 0 ? void 0 : option.options) === null || _a === void 0 ? void 0 : _a.forEach((z) => {
                                    if (z.name === subFeatureName) {
                                        subFeature2 = z;
                                    }
                                });
                            });
                        }
                    });
                }
                const selectedOption4 = (_f = subFeature2 === null || subFeature2 === void 0 ? void 0 : subFeature2.options) === null || _f === void 0 ? void 0 : _f.find((option) => {
                    return option.name === userConfiguration2[(subFeature2 === null || subFeature2 === void 0 ? void 0 : subFeature2.name) || ""];
                });
                return selectedOption4 ? [selectedOption4] : [];
            default:
                return [];
        }
    };
    const getRules = () => {
        const rules = {};
        Object.keys(userConfiguration2).forEach((key) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28;
            switch (key) {
                // case AccessoriesFeatureName:
                case MetalFeatureName:
                case MechanismFeatureName:
                case GlassesFeatureName:
                case FabricFeatureName:
                case WoodFeatureName:
                case bw:
                case lc:
                case WheelsFeatureName:
                case btt:
                case Pcolor:
                case PedestalFeatureLockName:
                case PedestalFeatureCushionName:
                case PedestalFeatureDrawerWoodName:
                case PedestalFeatureSideWoodName:
                case sf:
                case ss:
                case wmrw:
                case wmp:
                case wmsr:
                case PedestalFeatureTopWoodName:
                case PedestalFeatureFabricName:
                case PedestalFeatureName:
                case SideTableFeatureName:
                    const legs = specs.find((x) => x.name === key);
                    const r1 = legs === null || legs === void 0 ? void 0 : legs.rules;
                    const r2 = (_a = getSelectedOption(key, "")) === null || _a === void 0 ? void 0 : _a.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[key] = [...(r1 || []), ...(r2 || [])];
                    //append screen size to nodes
                    // if (key === AccessoriesFeatureName) {
                    //   const mainScreen = getSelectedOption(
                    //     PrivacyFeatureName,
                    //     "Main screen"
                    //   );
                    //   if (mainScreen && mainScreen.length > 0) {
                    //     let screenSize =
                    //       mainScreen &&
                    //       mainScreen[0]?.name?.substr(mainScreen[0]?.name.length - 4, 4);
                    //     screenSize = screenSize?.split("H")[0];
                    //     rules[key] = rules[key].map((rule) => {
                    //       return {
                    //         ...rule,
                    //         node: rule.node.map(
                    //           (nodeName) => nodeName + "_" + screenSize
                    //         ),
                    //       };
                    //     });
                    //   } else {
                    //     rules[key] = rules[key].map((rule) => {
                    //       return {
                    //         ...rule,
                    //         node: rule.node.map((nodeName) => nodeName),
                    //       };
                    //     });
                    //   }
                    // }
                    break;
                case "Base":
                    // case "Wire Entry":
                    const emtBase = getSelectedOption(BaseFeatureName, "Raceway");
                    const emtOptionBase = emtBase &&
                        ((_c = (_b = emtBase[0]) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.find((x) => x.name === key));
                    const r5Base = emtOptionBase === null || emtOptionBase === void 0 ? void 0 : emtOptionBase.rules;
                    const r6Base = (_d = getSelectedOption(BaseFeatureName, key)) === null || _d === void 0 ? void 0 : _d.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[BaseFeatureName] = [
                        ...(rules[BaseFeatureName] || []),
                        ...(r5Base || []),
                        ...(r6Base || []),
                    ];
                    return;
                case "Legs":
                case "Non Sharing Legs":
                case "Sharing Legs":
                case "Pedestal's Legs":
                case "Plan Legs":
                case "ATT Options":
                case "Plan Legs(NS)":
                    const emtLeg = getSelectedOption(LegsFeatureName, "Legs");
                    const emtOptionLeg = emtLeg &&
                        ((_f = (_e = emtLeg[0]) === null || _e === void 0 ? void 0 : _e.options) === null || _f === void 0 ? void 0 : _f.find((x) => x.name === key));
                    const r7 = emtOptionLeg === null || emtOptionLeg === void 0 ? void 0 : emtOptionLeg.rules;
                    const r8 = (_g = getSelectedOption(LegsFeatureName, key)) === null || _g === void 0 ? void 0 : _g.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[LegsFeatureName] = [
                        ...(rules[LegsFeatureName] || []),
                        ...(r7 || []),
                        ...(r8 || []),
                    ];
                    return;
                case "Leg":
                    const emtLegs = getSelectedOption(LegsFeatureName, "Legs");
                    const emtOptionLegs = emtLegs &&
                        ((_j = (_h = emtLegs[0]) === null || _h === void 0 ? void 0 : _h.options) === null || _j === void 0 ? void 0 : _j.find((x) => x.name === key));
                    const r7s = emtOptionLegs === null || emtOptionLegs === void 0 ? void 0 : emtOptionLegs.rules;
                    const r8s = (_k = getSelectedOption(LegsFeatureName, key)) === null || _k === void 0 ? void 0 : _k.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[LegsFeatureName] = [
                        ...(rules[LegsFeatureName] || []),
                        ...(r7s || []),
                        ...(r8s || []),
                    ];
                    return;
                case "C Cluster Legs":
                case "C Cluster Legs Sharing":
                case "Plan Legs":
                case "ATT Options":
                case "Plan Legs(NS)":
                    const emtCClusterLegs = getSelectedOption(CClusterLegsFeatureName, "C Cluster Legs");
                    const emtOptionCClusterLegs = emtCClusterLegs &&
                        ((_m = (_l = emtCClusterLegs[0]) === null || _l === void 0 ? void 0 : _l.options) === null || _m === void 0 ? void 0 : _m.find((x) => x.name === key));
                    const ruleU = emtOptionCClusterLegs === null || emtOptionCClusterLegs === void 0 ? void 0 : emtOptionCClusterLegs.rules;
                    const ruleV = (_o = getSelectedOption(CClusterLegsFeatureName, key)) === null || _o === void 0 ? void 0 : _o.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[CClusterLegsFeatureName] = [
                        ...(rules[CClusterLegsFeatureName] || []),
                        ...(ruleU || []),
                        ...(ruleV || []),
                    ];
                    return;
                case "Hand Rest":
                    const emtHR = getSelectedOption(HandRestFeatureName, "Legs");
                    const emtOptionHR = emtHR &&
                        ((_q = (_p = emtHR[0]) === null || _p === void 0 ? void 0 : _p.options) === null || _q === void 0 ? void 0 : _q.find((x) => x.name === key));
                    const r7HR = emtOptionHR === null || emtOptionHR === void 0 ? void 0 : emtOptionHR.rules;
                    const r8HR = (_r = getSelectedOption(HandRestFeatureName, key)) === null || _r === void 0 ? void 0 : _r.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[HandRestFeatureName] = [
                        ...(rules[HandRestFeatureName] || []),
                        ...(r7HR || []),
                        ...(r8HR || []),
                    ];
                    return;
                case "Pedestal":
                    const emtPed = getSelectedOption("Pedestal", "Pedestal");
                    const emtOptionPed = emtPed &&
                        ((_t = (_s = emtPed[0]) === null || _s === void 0 ? void 0 : _s.options) === null || _t === void 0 ? void 0 : _t.find((x) => x.name === key));
                    const r77 = emtOptionPed === null || emtOptionPed === void 0 ? void 0 : emtOptionPed.rules;
                    const r88 = (_u = getSelectedOption("Pedestal", key)) === null || _u === void 0 ? void 0 : _u.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[LegsFeatureName] = [
                        ...(rules["Pedestal"] || []),
                        ...(r77 || []),
                        ...(r88 || []),
                    ];
                    return;
                case LegColorFeatureName:
                    const emtLegColor = getSelectedOption(LegsFeatureName, LegColorFeatureName);
                    const emtOptionLegColor = emtLegColor &&
                        ((_w = (_v = emtLegColor[0]) === null || _v === void 0 ? void 0 : _v.options) === null || _w === void 0 ? void 0 : _w.find((x) => x.name === key));
                    const r11 = emtOptionLegColor === null || emtOptionLegColor === void 0 ? void 0 : emtOptionLegColor.rules;
                    const r12 = (_x = getSelectedOption(LegsFeatureName, key)) === null || _x === void 0 ? void 0 : _x.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[LegsFeatureName] = [
                        ...(rules[LegsFeatureName] || []),
                        ...(r11 || []),
                        ...(r12 || []),
                    ];
                    return;
                case ColorOptionsPrivacy:
                    const fabricColor = getSelectedOption(LegsFeatureName, LegColorFeatureName);
                    const fabricOptionLegColor = fabricColor &&
                        ((_z = (_y = fabricColor[0]) === null || _y === void 0 ? void 0 : _y.options) === null || _z === void 0 ? void 0 : _z.find((x) => x.name === key));
                    const r111 = fabricOptionLegColor === null || fabricOptionLegColor === void 0 ? void 0 : fabricOptionLegColor.rules;
                    const r122 = (_0 = getSelectedOption("Privacy", key)) === null || _0 === void 0 ? void 0 : _0.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules["Privacy"] = [
                        ...(rules["Privacy"] || []),
                        ...(r111 || []),
                        ...(r122 || []),
                    ];
                    return;
                case "SHARING":
                case "NON SHARING":
                case "WorkStation":
                case "Three Seater":
                    const privacyppT = specs.find((x) => x.name === "System");
                    const msppT = (_1 = privacyppT === null || privacyppT === void 0 ? void 0 : privacyppT.options) === null || _1 === void 0 ? void 0 : _1.find((x) => x.name === key);
                    const r9ppT = msppT === null || msppT === void 0 ? void 0 : msppT.rules;
                    const r10ppT = (_2 = getSelectedOption("System", key)) === null || _2 === void 0 ? void 0 : _2.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules["System"] = [
                        ...(rules["System"] || []),
                        ...(r9ppT || []),
                        ...(r10ppT || []),
                    ];
                    return;
                case "Handle":
                case "Handle's Color":
                    const privacyy = specs.find((x) => x.name === PedestalFeatureHandleName);
                    const mss = (_3 = privacyy === null || privacyy === void 0 ? void 0 : privacyy.options) === null || _3 === void 0 ? void 0 : _3.find((x) => x.name === key);
                    const r1111 = mss === null || mss === void 0 ? void 0 : mss.rules;
                    const r1222 = (_4 = getSelectedOption(PedestalFeatureHandleName, key)) === null || _4 === void 0 ? void 0 : _4.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[PedestalFeatureHandleName] = [
                        ...(rules[PedestalFeatureHandleName] || []),
                        ...(r1111 || []),
                        ...(r1222 || []),
                    ];
                    return;
                case "Plain Raceway OptionS":
                    const privacyyWwm1 = specs.find((x) => x.name === wm1);
                    const mssWwm1 = (_5 = privacyyWwm1 === null || privacyyWwm1 === void 0 ? void 0 : privacyyWwm1.options) === null || _5 === void 0 ? void 0 : _5.find((x) => x.name === key);
                    const r1111Wwm1 = mssWwm1 === null || mssWwm1 === void 0 ? void 0 : mssWwm1.rules;
                    const r1222Wwm1 = (_6 = getSelectedOption(wm1, key)) === null || _6 === void 0 ? void 0 : _6.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[wm1] = [
                        ...(rules[wm1] || []),
                        ...(r1111Wwm1 || []),
                        ...(r1222Wwm1 || []),
                    ];
                    return;
                case "Side Radius Raceway OptionS":
                    const privacyyWwm2 = specs.find((x) => x.name === wm2);
                    const mssWwm2 = (_7 = privacyyWwm2 === null || privacyyWwm2 === void 0 ? void 0 : privacyyWwm2.options) === null || _7 === void 0 ? void 0 : _7.find((x) => x.name === key);
                    const r1111Wwm2 = mssWwm2 === null || mssWwm2 === void 0 ? void 0 : mssWwm2.rules;
                    const r1222Wwm2 = (_8 = getSelectedOption(wm2, key)) === null || _8 === void 0 ? void 0 : _8.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[wm2] = [
                        ...(rules[wm2] || []),
                        ...(r1111Wwm2 || []),
                        ...(r1222Wwm2 || []),
                    ];
                    return;
                case "Length":
                case "Depth":
                    const privacyyW = specs.find((x) => x.name === Dimensions);
                    const mssW = (_9 = privacyyW === null || privacyyW === void 0 ? void 0 : privacyyW.options) === null || _9 === void 0 ? void 0 : _9.find((x) => x.name === key);
                    const r1111W = mssW === null || mssW === void 0 ? void 0 : mssW.rules;
                    const r1222W = (_10 = getSelectedOption(Dimensions, key)) === null || _10 === void 0 ? void 0 : _10.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[Dimensions] = [
                        ...(rules[Dimensions] || []),
                        ...(r1111W || []),
                        ...(r1222W || []),
                    ];
                    return;
                case "Return":
                case "Back":
                case "Return Table Top Leg":
                    const privacyppb = specs.find((x) => x.name === Storages);
                    const msppb = (_11 = privacyppb === null || privacyppb === void 0 ? void 0 : privacyppb.options) === null || _11 === void 0 ? void 0 : _11.find((x) => x.name === key);
                    const r9ppb = msppb === null || msppb === void 0 ? void 0 : msppb.rules;
                    const r10ppb = (_12 = getSelectedOption(Storages, key)) === null || _12 === void 0 ? void 0 : _12.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[Storages] = [
                        ...(rules[Storages] || []),
                        ...(r9ppb || []),
                        ...(r10ppb || []),
                    ];
                    return;
                case "Fabric's Color":
                case "Glass's Color":
                    const privacyyWpco = specs.find((x) => x.name === pco);
                    const mssWpco = (_13 = privacyyWpco === null || privacyyWpco === void 0 ? void 0 : privacyyWpco.options) === null || _13 === void 0 ? void 0 : _13.find((x) => x.name === key);
                    const r1111Wpco = mssWpco === null || mssWpco === void 0 ? void 0 : mssWpco.rules;
                    const r1222Wpco = (_14 = getSelectedOption(pco, key)) === null || _14 === void 0 ? void 0 : _14.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[pco] = [
                        ...(rules[pco] || []),
                        ...(r1111Wpco || []),
                        ...(r1222Wpco || []),
                    ];
                    return;
                case "Table Top Options":
                case "Table Top Options Sharing":
                    const privacyppt = specs.find((x) => x.name === tt);
                    const msppt = (_15 = privacyppt === null || privacyppt === void 0 ? void 0 : privacyppt.options) === null || _15 === void 0 ? void 0 : _15.find((x) => x.name === key);
                    const r9ppt = msppt === null || msppt === void 0 ? void 0 : msppt.rules;
                    const r10ppt = (_16 = getSelectedOption(tt, key)) === null || _16 === void 0 ? void 0 : _16.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[tt] = [
                        ...(rules[tt] || []),
                        ...(r9ppt || []),
                        ...(r10ppt || []),
                    ];
                    return;
                case "Wood Options":
                case "Main screen":
                case "Return screen":
                case "Main Modesty":
                case "MID Modesty":
                case "Side Panel":
                case "Left Side Panel Options":
                case "Left Side Panel Glass Color":
                case "Left Side Panel Laminate Color":
                case "Left Side Panel Fabric Color":
                case "Right Side Panel Options":
                case "Right Side Panel Glass Color":
                case "Right Side Panel Laminate Color":
                case "Right Side Panel Fabric Color":
                case "Side Modesty":
                case "Mid Modesty":
                case "Side Modesty (S)":
                case "Mid Modesty (S)":
                case "Side Modesty (NS)":
                case "Mid Modesty (NS)":
                case "Mid Panel":
                case "Mid Panel Options":
                case "Mid Panel Glass Color":
                case "Mid Panel Fabric Color":
                case "Mid Panel Laminate Color":
                case "Privacy Panels":
                case "Privacy Panels (S)":
                case "Privacy Panels (NS)":
                    const privacypp = specs.find((x) => x.name === PrivacyFeatureName);
                    const mspp = (_17 = privacypp === null || privacypp === void 0 ? void 0 : privacypp.options) === null || _17 === void 0 ? void 0 : _17.find((x) => x.name === key);
                    const r9pp = mspp === null || mspp === void 0 ? void 0 : mspp.rules;
                    const r10pp = (_18 = getSelectedOption(PrivacyFeatureName, key)) === null || _18 === void 0 ? void 0 : _18.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[PrivacyFeatureName] = [
                        ...(rules[PrivacyFeatureName] || []),
                        ...(r9pp || []),
                        ...(r10pp || []),
                    ];
                    return;
                case "Return Panels":
                case "Return Panels (S)":
                case "Return Panels (NS)":
                case "Middle Panels":
                case "Main Panels":
                case "Metal Options":
                case "Main Screen":
                case "End to End Panel Options":
                case "Aluminium Panel Options":
                case "Fabric Panel Accessories":
                case "End to End Panel Options (S)":
                case "Aluminium Panel Options (S)":
                case "Intermediate Panels (S)":
                case "Intermediate Panels (NS)":
                case "Fabric Panel Accessories (S)":
                case "End to End Panel Options (NS)":
                case "Aluminium Panel Options (NS)":
                case "Fabric Panel Accessories (NS)":
                    const privacy = specs.find((x) => x.name === PrivacyFeatureName);
                    const ms = (_19 = privacy === null || privacy === void 0 ? void 0 : privacy.options) === null || _19 === void 0 ? void 0 : _19.find((x) => x.name === key);
                    const r9 = ms === null || ms === void 0 ? void 0 : ms.rules;
                    const r10 = (_20 = getSelectedOption(PrivacyFeatureName, key)) === null || _20 === void 0 ? void 0 : _20.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[PrivacyFeatureName] = [
                        ...(rules[PrivacyFeatureName] || []),
                        ...(r9 || []),
                        ...(r10 || []),
                    ];
                    return;
                case "Return Panel":
                case "Middle Panel":
                case "Return Frame Pannel Dimension":
                case "Main Panel":
                case "Metal Option":
                case "Main Screens":
                case "Wood Option":
                case "Metal Option":
                    const privacyyy = specs.find((x) => x.name === attp);
                    const msyy = (_21 = privacyyy === null || privacyyy === void 0 ? void 0 : privacyyy.options) === null || _21 === void 0 ? void 0 : _21.find((x) => x.name === key);
                    const r9yy = msyy === null || msyy === void 0 ? void 0 : msyy.rules;
                    const r10yy = (_22 = getSelectedOption(attp, key)) === null || _22 === void 0 ? void 0 : _22.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[attp] = [
                        ...(rules[attp] || []),
                        ...(r9yy || []),
                        ...(r10yy || []),
                    ];
                    return;
                ////
                case "Plain Raceway Options":
                case "Reverse Waterfall Raceway Options":
                case "Side Radius Raceway Options":
                case "Raceway":
                case "Raceway (s)":
                case "Raceway Sharing":
                case "Wire Management's Dimensions Non Sharing":
                case "Wire Management":
                case "Wire Management's Dimensions Sharing":
                case "Wire Management's Dimensions":
                case "Raceway Sharing":
                case "Raceway Non Sharing":
                    const privacyw = specs.find((x) => x.name === WireManagement2);
                    const msw = (_23 = privacyw === null || privacyw === void 0 ? void 0 : privacyw.options) === null || _23 === void 0 ? void 0 : _23.find((x) => x.name === key);
                    const r9w = msw === null || msw === void 0 ? void 0 : msw.rules;
                    const r10w = (_24 = getSelectedOption(WireManagement2, key)) === null || _24 === void 0 ? void 0 : _24.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[WireManagement2] = [
                        ...(rules[WireManagement2] || []),
                        ...(r9w || []),
                        ...(r10w || []),
                    ];
                    return;
                case "Below Table TableTop Tile":
                case "Below Table TableTop Tile Colors":
                    const privacyppbt = specs.find((x) => x.name === btable);
                    const msppbt = (_25 = privacyppbt === null || privacyppbt === void 0 ? void 0 : privacyppbt.options) === null || _25 === void 0 ? void 0 : _25.find((x) => x.name === key);
                    const r9ppbt = msppbt === null || msppbt === void 0 ? void 0 : msppbt.rules;
                    const r10ppbt = (_26 = getSelectedOption(btable, key)) === null || _26 === void 0 ? void 0 : _26.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[btable] = [
                        ...(rules[btable] || []),
                        ...(r9ppbt || []),
                        ...(r10ppbt || []),
                    ];
                    return;
                case "Keyboard Trays":
                case "CPU Stands":
                case "Keyboard Trays (S)":
                case "CPU Stands (S)":
                case "Keyboard Trays (NS)":
                case "CPU Stands (NS)":
                    const accessories = specs.find((x) => x.name === AccessoriesFeatureName);
                    const ams = (_27 = accessories === null || accessories === void 0 ? void 0 : accessories.options) === null || _27 === void 0 ? void 0 : _27.find((x) => x.name === key);
                    const ar9 = ams === null || ams === void 0 ? void 0 : ams.rules;
                    const ar10 = (_28 = getSelectedOption(AccessoriesFeatureName, key)) === null || _28 === void 0 ? void 0 : _28.reduce((rules, option) => [...rules, ...((option === null || option === void 0 ? void 0 : option.rules) || [])], []);
                    rules[AccessoriesFeatureName] = [
                        ...(rules[AccessoriesFeatureName] || []),
                        ...(ar9 || []),
                        ...(ar10 || []),
                    ];
                    return;
                default:
                    break;
            }
        });
        const evaluateMultipleConditions = (multipleConditions, userConfig) => {
            let result = true;
            let currentOperator = "AND";
            for (let i = 0; i < multipleConditions.length; i++) {
                const condition = multipleConditions[i];
                if ("operator" in condition) {
                    currentOperator = condition.operator;
                }
                else {
                    const conditionMet = condition.values.includes(userConfig[condition.feature]);
                    if (currentOperator === "AND") {
                        result = result && conditionMet;
                    }
                    else if (currentOperator === "OR") {
                        result = result || conditionMet;
                    }
                }
            }
            return result;
        };
        const parseConditions = (rules) => {
            let cc = rules.filter((rule) => {
                var _a, _b;
                let filter = true;
                (_a = rule.condition) === null || _a === void 0 ? void 0 : _a.forEach((condition) => {
                    condition.values.includes(userConfiguration2[condition.feature])
                        ? (filter = true)
                        : (filter = false);
                });
                (_b = rule.conditionAnd) === null || _b === void 0 ? void 0 : _b.forEach((condition) => {
                    condition.values1.includes(userConfiguration2[condition.feature1]) &&
                        condition.values2.includes(userConfiguration2[condition.feature2])
                        ? (filter = true)
                        : (filter = false);
                });
                if (rule.multipleConditions) {
                    filter = evaluateMultipleConditions(rule.multipleConditions, userConfiguration2);
                }
                return filter;
            });
            return cc;
        };
        Object.keys(rules).forEach((key) => {
            rules[key] = parseConditions(rules[key]);
        });
        return rules;
    };
    return {
        updateUserConfiguration,
        userConfiguration2,
        getSelectedOption,
        getRules,
    };
};
export default useUserConfiguration;
